import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import type { AnalyticGranularity } from '@/modules/finances/types';
interface RowHeaderProps extends React.HTMLAttributes<HTMLTableCellElement> {
  granularity: AnalyticGranularity;
  isHeader: boolean;
  isUncategorized: boolean;
  children: React.ReactNode;
}
function RowHeader(t0) {
  const $ = _c(17);
  let children;
  let className;
  let granularity;
  let isUncategorized;
  let props;
  if ($[0] !== t0) {
    const {
      granularity: t1,
      isHeader: _isHeader,
      isUncategorized: t2,
      className: t3,
      children: t4,
      ...t5
    } = t0;
    granularity = t1;
    isUncategorized = t2;
    className = t3;
    children = t4;
    props = t5;
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = granularity;
    $[4] = isUncategorized;
    $[5] = props;
  } else {
    children = $[1];
    className = $[2];
    granularity = $[3];
    isUncategorized = $[4];
    props = $[5];
  }
  const isQuarterly = granularity === "quarterly";
  const isAnnual = granularity === "annual";
  const isMonthly = granularity === "monthly";
  const isSemiAnnual = granularity === "semiAnnual";
  let t1;
  if ($[6] !== className || $[7] !== isAnnual || $[8] !== isMonthly || $[9] !== isQuarterly || $[10] !== isSemiAnnual || $[11] !== isUncategorized) {
    t1 = cn("border-border text-foreground relative w-full border-r py-4 text-xs", "overflow-wrap-anywhere wrap-break-word", isUncategorized && "italic", isMonthly && ["w-[195px] px-2 py-4 pl-8 text-sm", "3xl:min-w-[230px]", "2xl:truncate"], isQuarterly && ["w-[145px] p-4 pr-2 text-sm", "lg:w-[148px] lg:pl-2", "xl:w-[220px] xl:px-8", "2xl:w-[260px] 2xl:px-8 2xl:pr-2", "3xl:w-[228px] 3xl:px-4"], isAnnual && ["w-[78px] px-2 py-4 text-xs", "md:w-[140px] md:p-4 md:px-2 md:text-base", "xl:w-[190px] xl:px-8 xl:py-4", "2xl:w-[170px] 2xl:truncate", "3xl:w-[195px]"], isSemiAnnual && ["w-[85px] px-2 py-4 pl-2", "md:w-[150px] md:px-4 md:text-sm"], className);
    $[6] = className;
    $[7] = isAnnual;
    $[8] = isMonthly;
    $[9] = isQuarterly;
    $[10] = isSemiAnnual;
    $[11] = isUncategorized;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  let t2;
  if ($[13] !== children || $[14] !== props || $[15] !== t1) {
    t2 = <th scope="row" className={t1} {...props}>{children}</th>;
    $[13] = children;
    $[14] = props;
    $[15] = t1;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  return t2;
}
export { RowHeader };